import { Button, Divider, Group, Popover, Stack, TextInput } from '@mantine/core';
import { IconCalendar, IconCheck, IconChevronDown } from '@tabler/icons-react';
import { useState } from 'react';
import { OPENED_PRESETS, presetRange, rangeLabel } from './opened-filter.util';

export interface OpenedFilterProps {
  after: string;
  before: string;
  onChange: (after: string, before: string) => void;
  today?: Date;
}

export function OpenedFilter({ after, before, onChange, today = new Date() }: OpenedFilterProps) {
  const [opened, setOpened] = useState(false);
  const label = rangeLabel(after, before, today);

  return (
    <Popover opened={opened} onChange={setOpened} position="bottom-start" withinPortal shadow="md">
      <Popover.Target>
        <Button
          variant="default"
          onClick={() => setOpened((o) => !o)}
          leftSection={<IconCalendar size={16} />}
          rightSection={<IconChevronDown size={16} />}
        >
          {label}
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap={4} w={240}>
          {OPENED_PRESETS.map((p) => {
            const isActive = label === p.label;
            return (
              <Button
                key={p.key}
                variant={isActive ? 'light' : 'subtle'}
                justify="space-between"
                rightSection={isActive ? <IconCheck size={16} /> : null}
                onClick={() => {
                  const r = presetRange(p.key, today);
                  onChange(r.after, r.before);
                  setOpened(false);
                }}
              >
                {p.label}
              </Button>
            );
          })}
          <Divider my={4} />
          <Group gap="xs" grow>
            <TextInput
              label="From"
              type="date"
              value={after}
              onChange={(e) => onChange(e.currentTarget.value, before)}
            />
            <TextInput
              label="To"
              type="date"
              value={before}
              onChange={(e) => onChange(after, e.currentTarget.value)}
            />
          </Group>
          <Button
            variant="subtle"
            color="gray"
            size="compact-sm"
            onClick={() => {
              onChange('', '');
              setOpened(false);
            }}
          >
            Clear
          </Button>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
